import { createReducer } from 'platform/shared/health-apps';

export const DISABILITY_RATING_ACTIONS = {
  STARTED: 'FETCH_DISABILITY_RATING_STARTED',
  SUCCEEDED: 'FETCH_DISABILITY_RATING_SUCCEEDED',
  FAILED: 'FETCH_DISABILITY_RATING_FAILED',
};

export const DISABILITY_RATING_INIT_STATE = {
  totalRating: null,
  loading: false,
  hasError: false,
};

const { STARTED, SUCCEEDED, FAILED } = DISABILITY_RATING_ACTIONS;

export const disabilityRatingReducer = createReducer(
  DISABILITY_RATING_INIT_STATE,
  {
    [STARTED]: () => ({ ...DISABILITY_RATING_INIT_STATE, loading: true }),
    [SUCCEEDED]: (state, { response }) => ({
      ...state,
      totalRating: response.userPercentOfDisability,
      loading: false,
      hasError: false,
    }),
    [FAILED]: state => ({ ...state, loading: false, hasError: true }),
  },
);
